var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$q.screen.gt.xs ? 'q-pa-xl' : 'q-pa-sm'},[_c('h1',{staticClass:"text-h5 q-pb-md q-my-md text-left fields-tab-header"},[_vm._v(" "+_vm._s(_vm.$store.getters.module_name)+" Reports ")]),_c('ReportsList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }